"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadOrganizationContacts = exports.saveOrganization = exports.loadOrganizations = void 0;

var _types = require("./types");

var loadOrganizations = function loadOrganizations(orgIds, enqueueSnackbar) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;
    dispatch({
      type: _types.ORGS_LOADING
    });
    return api.getOrganizations(orgIds).then(function (orgs) {
      return dispatch({
        type: _types.ORGS_SUCCESS,
        payload: orgs
      });
    }).catch(function (err) {
      console.error(err);

      if (enqueueSnackbar) {
        enqueueSnackbar(err.message, {
          variant: 'error'
        });
      }
    });
  };
};

exports.loadOrganizations = loadOrganizations;

var saveOrganization = function saveOrganization(organization, enqueueSnackbar) {
  return function (dispatch, getState, _ref2) {
    var api = _ref2.api;
    return api.saveOrganization(organization).then(function (org) {
      return dispatch({
        type: _types.ORG_SUCCESS,
        payload: org
      });
    }).catch(function (err) {
      console.error(err);

      if (enqueueSnackbar) {
        enqueueSnackbar(err.message, {
          variant: 'error'
        });
      }
    });
  };
};

exports.saveOrganization = saveOrganization;

var loadOrganizationContacts = function loadOrganizationContacts(orgId, setLoading, setContacts, enqueueSnackbar) {
  return function (dispatch, getState, _ref3) {
    var api = _ref3.api;
    return api.getOrganization(orgId).then(function (org) {
      setLoading(false);
      setContacts(org.emails);
    }).catch(function (err) {
      console.error(err);
      setLoading(false);

      if (enqueueSnackbar) {
        enqueueSnackbar(err.message, {
          variant: 'error'
        });
      }
    });
  };
};

exports.loadOrganizationContacts = loadOrganizationContacts;